import FilePreviewModal from "@Platon/components/misc/preview/FilePreviewModal.vue"

export default {
	methods: {
		/**
		 * @param {PlatonFile} remoteFile
		 */
		openFilePreviewModal(remoteFile) {
			this.$modal.show(
				FilePreviewModal,
				{
					remoteFile
				},
				{
					height: "90%",
					maxHeight: window.innerHeight * 0.9
				}
			)
		}
	}
}
